import { createClient } from "@liveblocks/client";
import { useAtom } from "jotai";
import { currentUserAtom } from "../jotai/atoms";

const useLiveblocksClient = () => {
  const [currentUser] = useAtom(currentUserAtom);
  const client = createClient({
    authEndpoint: `/api/liveblocks${
      currentUser?.id ? `?user=${currentUser.id}` : ""
    }`,
  });
  return client;
};

export default useLiveblocksClient;
